import {ProductsRelDocs} from "../../interfaces";
interface IProductBuyButtonProps {
    product: ProductsRelDocs,
    isGoogleShoppingFeed?: boolean,
}
/**
 * the entry point
 */
const PRDCouponHTML = (props: IProductBuyButtonProps) => {

    const product = props.product;

    return (

            <>
                {
                    <div className="w-full flex flex-wrap justify-start">
                        <div dangerouslySetInnerHTML={{ __html: product.couponStripeHTML }} />
                    </div>
                }
            </>
    )
};

export default PRDCouponHTML;